import React, { ReactNode } from "react";
import { message, Popconfirm } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import useTranslation from "@/hooks/useTranslation";
import {
  TravelMode,
  useDeleteTravelModeReferences,
} from "@/pages/employee/travel_modes/useTravelMode";

function DeleteTravelModelAction({
  selectedTravelModes,
  onSuccess,
  children,
}: {
  selectedTravelModes: TravelMode[];
  onSuccess?: () => void;
  children: ReactNode;
}) {
  const deleteTravalModeReference = useDeleteTravelModeReferences();
  const translation = useTranslation();

  const onDelete = () => {
    return deleteTravalModeReference
      .mutateAsync({
        travelModeIds: selectedTravelModes.map((mode) => mode.id),
      })
      .then(() => {
        message.success(translation.employee.travel_modes.deletePopConfirm.successMessage);
        onSuccess?.();
      })
      .catch(() => {
        message.error(translation.errors.general);
      });
  };

  return (
    <Popconfirm
      title={translation.employee.travel_modes.deletePopConfirm.title}
      description={
        <>
          <p>{translation.employee.travel_modes.deletePopConfirm.description}</p>
        </>
      }
      disabled={selectedTravelModes.length === 0}
      onConfirm={onDelete}
      onCancel={() => {}}
      icon={<ExclamationCircleFilled style={{ color: "#F5222D" }} />}
      okText={translation.employee.travel_modes.deletePopConfirm.okText}
      cancelText={translation.employee.travel_modes.deletePopConfirm.cancelText}
      placement="bottom"
      okType="danger"
      okButtonProps={{ loading: deleteTravalModeReference.isLoading }}
    >
      {children}
    </Popconfirm>
  );
}

export default DeleteTravelModelAction;
